<template>
    <v-dialog v-model="modal" :scrim="false" width="800" content-class="overflow--visible">
        <v-card>
            <v-card-title class="text-white bg-primary">
                {{ service.serviceName }}
            </v-card-title>
            <v-card-text class="text-capitalize mt-6">
                <div v-if="!edit">
                    {{ $t('due_to_confirm_by') }}
                    {{ $filters.dateTimeFormat(service.dueToConfirmDate) }}
                    <v-btn size="x-small" color="primary" icon="mdi-pencil" variant="text" @click="edit = !edit" />
                </div>
                <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
                <vc-date-picker
                    v-else
                    v-model.string="dueToConfirmDate"
                    :locale="$i18n.locale"
                    :min-date="$dateFns.format(new Date())"
                    :max-date="service.startDateTime"
                    :first-day-of-week="$conf.public.firstDayOfWeek || undefined"
                    mode="dateTime"
                    :masks="masks"
                    is24hr
                    is-required
                >
                    <template v-slot="{inputEvents}">
                        <div v-on="inputEvents">
                            <v-text-field
                                :label="$t('due_to_confirm_by')"
                                readonly
                                variant="outlined"
                                hide-details
                                bg-color="white"
                                prepend-inner-icon="mdi-av-timer"
                                :append-icon="modifyActive ? 'mdi-loading mdi-spin' : 'mdi-check'"
                                :model-value="$filters.dateTimeFormat(dueToConfirmDate)"
                                density="compact"
                                @click:append="modify"
                            />
                        </div>
                    </template>
                </vc-date-picker>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn
                    variant="flat"
                    color="primary"
                    :loading="confirmPrebookingActive"
                    :disabled="disabled"
                    @click="confirmPrebooking"
                >
                    {{ $t('book') }}
                </v-btn>
                <v-btn
                    variant="flat"
                    color="warning"
                    :loading="cancelServiceActive"
                    :disabled="disabled"
                    @click="cancelService"
                >
                    {{ $t('cancel_prebooking') }}
                </v-btn>
                <v-btn variant="flat" :disabled="disabled" @click="modal = false">
                    {{ $t('cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Emit, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_DUE_TO_CONFIRM_DATE_SERVICE_MODAL} from '@/utils/event-bus'

    @Component
    export class DueToConfirmDateServiceModal extends Vue {
        modal = false
        service = {}
        confirmPrebookingActive = false
        cancelServiceActive = false
        modifyActive = false
        dueToConfirmDate = null
        edit = false
        orderId = null

        @Emit()
        loadOrder() {}

        mounted() {
            EventBus.$on(SHOW_DUE_TO_CONFIRM_DATE_SERVICE_MODAL, this.show)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_DUE_TO_CONFIRM_DATE_SERVICE_MODAL, this.show)
        }

        show({service, orderId}) {
            this.service = service
            this.dueToConfirmDate = service.dueToConfirmDate
            this.orderId = orderId
            this.modal = true
        }

        async confirmPrebooking() {
            try {
                this.confirmPrebookingActive = true
                await this.$api.confirmPrebooking.put({processId: this.service.processId})
                if (this.$conf.public.reservationReport && this.service.processId) {
                    await this.markAsNotSentToSupplier()
                }
                this.modal = false
                this.loadOrder()
            } catch (e) {
                console.error(e)
            } finally {
                this.confirmPrebookingActive = false
            }
        }

        async cancelService() {
            try {
                this.cancelServiceActive = true
                await this.$api.cancelService.post({processId: this.service.processId})
                if (this.$conf.public.reservationReport && this.service.processId) {
                    await this.markAsNotSentToSupplier()
                }
                this.modal = false
                this.loadOrder()
            } catch (e) {
                console.error(e)
            } finally {
                this.cancelServiceActive = false
            }
        }

        async modify() {
            if (this.dueToConfirmDate === this.service.dueToConfirmDate || this.modifyActive) return
            try {
                this.modifyActive = true
                await this.$api.manualModification.post({
                    processId: this.service.processId,
                    status: 'PRE-BOOKING',
                    dueToConfirmDate: this.dueToConfirmDate,
                })
                if (this.$conf.public.reservationReport && this.service.processId) {
                    await this.markAsNotSentToSupplier()
                }
                this.modal = false
                this.loadOrder()
            } catch (e) {
                console.error(e)
            } finally {
                this.modifyActive = false
            }
        }

        async markAsNotSentToSupplier() {
            await this.$api.orders.put(this.orderId, {
                servicesInfo: [
                    {
                        processId: this.service.processId,
                        serviceSentToSupplier: false,
                    },
                ],
            })
        }

        get masks() {
            return {modelValue: 'YYYY-MM-DDTHH:mm'}
        }

        get disabled() {
            return this.confirmPrebookingActive || this.cancelServiceActive
        }
    }

    export default DueToConfirmDateServiceModal
</script>
